document.addEventListener( 'DOMContentLoaded', () => {
	const toggle = document.getElementById( 'anacrm-menu-toggle' );
	const menu = document.getElementById( 'anacrm-primary-menu' );
	if ( ! toggle || ! menu ) {
		return;
	}

	toggle.addEventListener( 'click', () => {
		const isOpen = ! menu.classList.contains( 'hidden' );
		menu.classList.toggle( 'hidden', isOpen );
		toggle.setAttribute( 'aria-expanded', String( ! isOpen ) );
	} );
} );

// Dropdown submenus (e.g. Profile sections in the header user menu).
document.addEventListener( 'DOMContentLoaded', () => {
	const dropdowns = document.querySelectorAll( '[data-anacrm-dropdown]' );

	const setOpen = ( dropdown, open ) => {
		const toggle = dropdown.querySelector(
			'[data-anacrm-dropdown-toggle]'
		);
		const list = dropdown.querySelector( 'ul' );
		if ( ! toggle || ! list ) {
			return;
		}
		list.classList.toggle( 'hidden', ! open );
		list.classList.toggle( 'flex', open );
		toggle.setAttribute( 'aria-expanded', String( open ) );
	};

	dropdowns.forEach( ( dropdown ) => {
		dropdown
			.querySelector( '[data-anacrm-dropdown-toggle]' )
			?.addEventListener( 'click', () => {
				const list = dropdown.querySelector( 'ul' );
				setOpen( dropdown, list.classList.contains( 'hidden' ) );
			} );
	} );

	document.addEventListener( 'click', ( e ) => {
		dropdowns.forEach( ( dropdown ) => {
			if ( ! dropdown.contains( e.target ) ) {
				setOpen( dropdown, false );
			}
		} );
	} );

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' ) {
			dropdowns.forEach( ( dropdown ) => {
				setOpen( dropdown, false );
				dropdown
					.querySelector( '[data-anacrm-dropdown-toggle]' )
					?.focus();
			} );
		}
	} );
} );
